import React from "react";
import { BiInfoCircle } from "react-icons/bi";
import SaveImage from "../../ModalImages/SaveImage";
import ListImage from "../../ModalImages/ListImage";
import DownIcon from "../../ModalImages/DownIcon";

function LandPaymentModal() {
  return (
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <span class="modal-btn" data-toggle="modal" data-target="#myModal2">
          <BiInfoCircle />
        </span>
      </div>

      <div
        class="modal right fade my-modal"
        id="myModal2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel2"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel2">
                Land Payment Info!
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <ul className="modal-ul">
                <li>
                  <h5>
                    <SaveImage />
                    Save and submit
                  </h5>
                  <ul>
                    <li>
                      <ListImage />
                      Update total land payment
                    </li>
                    <li>
                      <ListImage />
                      Update land installment amount.
                    </li>
                    <li>
                      <ListImage />
                      Set status of land
                    </li>
                    <li>
                      <ListImage />
                      Update total land payment
                    </li>
                    <li>
                      <DownIcon />
                      Transactions are:
                      <ul>
                        <li>
                          <ListImage />
                          Debit account = Land creditor’s account debit with net
                          paid amount.
                        </li>
                        <li>
                          <ListImage />
                          Credit account = Cash/Bank account credit with net
                          paid amount.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandPaymentModal;
